//Set up global vee-validate rules available throughout the application.
import { defineRule, configure } from 'vee-validate';
import {alpha_num, email, min, required, regex} from '@vee-validate/rules';
import { localize, setLocale } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import es from '@vee-validate/i18n/dist/locale/es.json';

//Only import the rules that we're using as best practice for JS bundle size.
defineRule('alpha_num', alpha_num);
defineRule('email', email);
defineRule('min', min);
defineRule('required', required);
defineRule('regex', regex);


//Define additional custom rules here.
defineRule('state_required', (value, [target]) => {
    if (!!value || target !== 'US') {
        return true;
    }

    return 'The state field is required for United States addresses.'; //TODO i18n TODO translate
});

defineRule('province_required', (value, [target]) => {
    if (!!value || target !== 'CA') {
        return true;
    }

    return 'The province field is required for Canadian addresses.'; //TODO i18n TODO translate
});

defineRule('valid_vue_tel_input', (value, target) => {
    if (target.valid) {
        return true;
    }

    return 'This phone number is not valid.'; //TODO i18n TODO translate
});

//Default, out of the box i18n. Any addition i18n, in particular, any additional translations, should take place in i18n.js
configure({
    generateMessage: localize({
        en,
        es,
    }),
});

setLocale('en'); //TODO use locale in state.
